<template>
    <div class="delivery-wrap">
        <div class="product-delivery-locations">
            <span class="product-delivery-city" @click.prevent="$parent.selectCity">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
                    <path d="M31.999,9.806c9.128,0,16.554,7.428,16.554,16.56c0,13.604-14.906,26.887-15.539,27.446 c-0.289,0.257-0.651,0.383-1.015,0.383c-0.36,0-0.723-0.126-1.011-0.383c-0.636-0.559-15.541-13.842-15.541-27.446 C15.447,17.234,22.874,9.806,31.999,9.806 M31.999,7.806c-10.229,0-18.552,8.326-18.552,18.56 c0,14.529,15.559,28.367,16.221,28.948c0.633,0.564,1.465,0.881,2.331,0.881c0.867,0,1.699-0.315,2.343-0.888 c1.655-1.461,16.211-14.72,16.211-28.941C50.553,16.132,42.229,7.806,31.999,7.806L31.999,7.806z"></path>
                    <path d="M31.999,21.784c2.523,0,4.568,2.044,4.568,4.568c0,2.521-2.045,4.567-4.568,4.567 c-2.521,0-4.566-2.046-4.566-4.567C27.433,23.829,29.478,21.784,31.999,21.784 M31.999,19.784c-3.621,0-6.566,2.946-6.566,6.568 c0,3.621,2.946,6.567,6.566,6.567c3.622,0,6.568-2.946,6.568-6.567C38.567,22.73,35.621,19.784,31.999,19.784L31.999,19.784z"></path>
                </svg>
                <span v-text="$parent.cityName"></span>
            </span>
            <a v-if="hasPickupPoints" class="product-delivery-pickup-point" @click.prevent="$parent.showPickupPoints()">
                {{ pickupPointsCountLabel() }}
            </a>
        </div>
        <div class="product-delivery-type">
            <div v-for="delivery in deliveries" class="product-delivery-type-item">
                <div class="cpdti-title">
                    <span :class="getClass(delivery.delivery_method_id)"></span>
                    {{ deliveryLabel(delivery) }}
                </div>

                <div class="payment-items">
                    <div v-for="payment in delivery.payments" class="payment-item">
                        <div class="cpdti-title">
                            <span>{{ paymentType(payment.payment_type_id) }}</span>
                            <span v-html="deliveryCost(payment.cost)"></span>
                        </div>
                        <span class="cpdti-date">
                            {{ deliveryDays(delivery) }},
                            {{ maxItemsCount(delivery) }}<template v-if="payment.try_on">,
                                примерка
                                <q-btn flat>
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 10.2451C6.85057 10.2451 7.13477 9.96092 7.13477 9.61035C7.13477 9.25978 6.85057 8.97559 6.5 8.97559C6.14943 8.97559 5.86523 9.25978 5.86523 9.61035C5.86523 9.96092 6.14943 10.2451 6.5 10.2451Z" fill="#BBBBBB"/>
                                        <path d="M6.5 0C2.90763 0 0 2.90715 0 6.5C0 10.0924 2.90715 13 6.5 13C10.0924 13 13 10.0928 13 6.5C13 2.90763 10.0928 0 6.5 0ZM6.5 11.9844C3.46894 11.9844 1.01562 9.53146 1.01562 6.5C1.01562 3.46894 3.46854 1.01562 6.5 1.01562C9.53106 1.01562 11.9844 3.46854 11.9844 6.5C11.9844 9.53106 9.53146 11.9844 6.5 11.9844Z" fill="#BBBBBB"/>
                                        <path d="M6.5 3.2627C5.37997 3.2627 4.46875 4.17391 4.46875 5.29395C4.46875 5.57441 4.6961 5.80176 4.97656 5.80176C5.25703 5.80176 5.48438 5.57441 5.48438 5.29395C5.48438 4.73393 5.93998 4.27832 6.5 4.27832C7.06002 4.27832 7.51562 4.73393 7.51562 5.29395C7.51562 5.85396 7.06002 6.30957 6.5 6.30957C6.21954 6.30957 5.99219 6.53692 5.99219 6.81738V8.08691C5.99219 8.36738 6.21954 8.59473 6.5 8.59473C6.78046 8.59473 7.00781 8.36738 7.00781 8.08691V7.26093C7.88293 7.03488 8.53125 6.23871 8.53125 5.29395C8.53125 4.17391 7.62003 3.2627 6.5 3.2627Z" fill="#BBBBBB"/>
                                    </svg>
                                    <q-tooltip anchor="top middle" self="bottom middle">
                                        <p>На примерку отводиться до 15 минут в непосредственной близости от торгового представителя.</p>
                                    </q-tooltip>
                                </q-btn></template>
                            <template v-if="payment.payment_type_id === 1 && delivery.delivery_method_id !== 3">,
                                частичный выкуп
                                <q-btn flat>
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 10.2451C6.85057 10.2451 7.13477 9.96092 7.13477 9.61035C7.13477 9.25978 6.85057 8.97559 6.5 8.97559C6.14943 8.97559 5.86523 9.25978 5.86523 9.61035C5.86523 9.96092 6.14943 10.2451 6.5 10.2451Z" fill="#BBBBBB"/>
                                        <path d="M6.5 0C2.90763 0 0 2.90715 0 6.5C0 10.0924 2.90715 13 6.5 13C10.0924 13 13 10.0928 13 6.5C13 2.90763 10.0928 0 6.5 0ZM6.5 11.9844C3.46894 11.9844 1.01562 9.53146 1.01562 6.5C1.01562 3.46894 3.46854 1.01562 6.5 1.01562C9.53106 1.01562 11.9844 3.46854 11.9844 6.5C11.9844 9.53106 9.53146 11.9844 6.5 11.9844Z" fill="#BBBBBB"/>
                                        <path d="M6.5 3.2627C5.37997 3.2627 4.46875 4.17391 4.46875 5.29395C4.46875 5.57441 4.6961 5.80176 4.97656 5.80176C5.25703 5.80176 5.48438 5.57441 5.48438 5.29395C5.48438 4.73393 5.93998 4.27832 6.5 4.27832C7.06002 4.27832 7.51562 4.73393 7.51562 5.29395C7.51562 5.85396 7.06002 6.30957 6.5 6.30957C6.21954 6.30957 5.99219 6.53692 5.99219 6.81738V8.08691C5.99219 8.36738 6.21954 8.59473 6.5 8.59473C6.78046 8.59473 7.00781 8.36738 7.00781 8.08691V7.26093C7.88293 7.03488 8.53125 6.23871 8.53125 5.29395C8.53125 4.17391 7.62003 3.2627 6.5 3.2627Z" fill="#BBBBBB"/>
                                    </svg>
                                    <q-tooltip anchor="top middle" self="bottom middle">
                                        <p>Вы выкупаете то что вам подошло и понравилось, остальное отдаете торговому представителю.</p>
                                    </q-tooltip>
                                </q-btn>
                            </template>
                        </span>
                    </div>
                </div>
            </div>
            <div class="product-delivery-type-item">
                <div class="free">
                    <span>Бесплатно</span> - при онлайн оплате и заказе свыше 5 000 руб.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Delivery',
    props: {
        list: {
            type: Array,
            required: true,
        }
    },
    mounted () {
        let _this = this;

        _this.$store.commit('geo/loadDeliveryDataOnCityChange');

        _this.$store.commit('delivery/setDeliveries', _this.list);
    },
    methods: {
        getClass (deliveryMethodId) {
            if (deliveryMethodId === 2) {
                return 'icon pickup';
            } else if (deliveryMethodId === 1) {
                return 'icon courier';
            } else if (deliveryMethodId === 3) {
                return 'icon russian-post';
            } else if (deliveryMethodId === 6) {
                return 'icon kc';
            }
        },
        deliveryDays (delivery) {
            return delivery.min_delivery_time + '-' + delivery.max_delivery_time + (delivery.max_delivery_time > 4 ? ' дней' : ' дня');
        },
        maxItemsCount (delivery) {
            let count = delivery.max_products_count ? delivery.max_products_count : 3;

            return `до ${count}-${count > 4 ? 'и' : 'x'} пар`;
        },
        deliveryCost (cost) {
            return cost
                ? this.$root.priceFormat(cost) + ' &#8381;'
                : 'Бесплатно';
        },
        paymentType (paymentTypeId) {
            let name = this.paymentTypeName(paymentTypeId);

            if (paymentTypeId === 1) {
                name = 'Оплата ' + name.toLowerCase();
            }

            return name;
        },
        deliveryLabel (delivery) {
            let method = this.deliveryMethodName(delivery.delivery_method_id);
            let service = this.deliveryServiceName(delivery.delivery_service_id);

            if (service.includes(method)) {
                return service;
            }

            if (method.endsWith(service)) {
                return method;
            }

            return method.replace(service, '') + ' ' + service;
        },
    },
    computed: {
        ...mapGetters('asset', [
            'deliveryMethodName',
            'deliveryServiceName',
            'paymentTypeName',
        ]),
        ...mapGetters('delivery', [
            'locationDeliveries',
            'deliveryMethodHasPickupPoints',
            'servicePickupPoints',
            'pickupPointsCountLabel'
        ]),
        deliveries () {
            let _this = this;

            return _this.$store.state.geo.location.region
                ? _this.locationDeliveries(_this.$store.state.geo.location.region.id, _this.$store.state.geo.location.city.id)
                : [];
        },
        hasPickupPoints () {
            for (let i in this.deliveries) {
                if (this.deliveryMethodHasPickupPoints(this.deliveries[i].delivery_method_id)) {
                    return true;
                }
            }

            return false;
        }
    }
}
</script>
